import {KeywordType} from '../constants';
import {KeywordTypeLabel} from '../locales';

export const getKeywordTypeLabel = (type: KeywordType) =>
	KeywordTypeLabel[type];

export default getKeywordTypeLabel;
